import { getDocumentDueDate } from '../../utils/documents.overview';
import { defineFormSchema } from '../../../../shared/data/formSchema';
import { DOCUMENT_STATUSES } from '../../utils/documents.constants';
export const documentFormSchema = defineFormSchema({
  id: 'documents.metadata',
  fields: [
    { name: 'name', label: 'Titolo', primary: true, table: { minWidth: 190 } },
    {
      name: 'clientId',
      label: 'Cliente',
      table: { accessor: (row) => row.clientResolvedName || row.client || 'Cliente non risolto' },
    },
    { name: 'category', label: 'Categoria' },
    { name: 'uploadedBy', label: 'Gestito da' },
    { name: 'dueDate', label: 'Scadenza', type: 'date', table: { accessor: getDocumentDueDate }, filter: { accessor: getDocumentDueDate } },
    { name: 'uploadDate', label: 'Data', type: 'date' },
    { name: 'teamMemberId', label: 'Team / Personale collegato', table: false, filter: { accessor: (row) => row.relations?.filter((item) => item.entityType === 'TEAM_MEMBER').map((item) => item.label || item.entityId) } },
    { name: 'fileName', label: 'Nome file', table: false },
    { name: 'status', label: 'Stato', type: 'select', options: DOCUMENT_STATUSES },
  ],
});
